const oktaConfig = {
	issuer: process.env.REACT_APP_OIDC_ISSUER,
	redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI,
	clientId: process.env.REACT_APP_OIDC_CLIENT_ID,
	scopes: ['openid', 'profile', 'email', 'groups'],
	pkce: true,
};

export default oktaConfig;
